import React, { useEffect, useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Image, Tag, Popover } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppTable } from "../../common";

interface Contentdata {
  key?: string;
  _id: number;
  title: string;
  type: string;
  content: string;
  link: string;
  image: string;
  sheduledDate: string;
}
// interface DataTableProps {
//     setshowModel: (value: boolean) => void,
//     setEditable: (value: boolean) => void,
//     deleteThought: (value: any) => void,
//     editContent:(value:any)=>void
//     isOpen: boolean,
//     contentData?: Contentdata[]
// }
function TimesFeaturedStoryTableContent({
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  deleteOtherContent,
  editContent,
  showModal,
}: any) {
  const [searchText, setSearchText] = useState("");

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "id",
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => a._id.localeCompare(b._id),
      onFilter: (value, record) => {
        return (
          String(record.title).toLowerCase().includes(value.toLocaleString()) ||
          String(record._id).toLowerCase().includes(value.toLocaleString()) ||
          String(record.content).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      render: (text) => (
        <>
          {/* <p>{text}</p> */}
          <p dangerouslySetInnerHTML={{ __html: text?.slice(0, 100) }} />
        </>
      ),
    },

    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <Space size="middle">
          <Image src={record.image} width={60} height={60} alt={"image"} />
        </Space>
      ),
    },
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    // {
    //   title: "Status",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   render: (_, record) => (
    //     <Space size="middle">
    //       {record.sheduledDate === null ? (
    //         <Tag color={"green"}>Published</Tag>
    //       ) : moment().format("YYYY-MM-DD") >= record.sheduledDate ? (
    //         <Tag color={"green"}>Published</Tag>
    //       ) : (
    //         <Tag color={"red"}>Not Published</Tag>
    //       )}
    //     </Space>
    //   ),
    // },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              setshowModel(!isOpen);
              setEditable(true);
              editContent(record);
            }}
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popover
            content={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Button
                  style={{ backgroundColor: "green", width: "100%", color: "#fff" }}
                  onDoubleClick={() => deleteOtherContent(record._id)}
                >
                  Yes
                </Button>
              </div>
            }
            title="Please Double click to delete."
          >
            <Button
              className="table_pill_btn table_pill_btn--danger"
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popover>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    console.log(contentData, "contentData");
  }, [contentData]);
  return (
    <div className="dataTable">
      <div className="filterMenu">
        <Button onClick={showModal} className="add_button">
          Add New Featured Story
        </Button>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default TimesFeaturedStoryTableContent;
